import { useEffect, useState } from 'react';
import { getUserInfo } from 'services/user';

interface UserInfo {
  nick_name: string;
  profile: string;
  state: number;
  uid: string;
  user_level: number;
  api_key_permission: boolean;
  vip_level: number;
  account_type: string;
  switch_able: boolean;
  sub_allow_login: boolean;
  messages: Record<string, string>;
}

const EMPTY_USER: UserInfo = {
  nick_name: '',
  profile: '',
  state: 0,
  uid: '',
  user_level: 0,
  api_key_permission: false,
  vip_level: 0,
  account_type: '',
  switch_able: false,
  sub_allow_login: false,
  messages: {},
};

export default function useUserInfo() {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getUserInfo<{ code: number; data: UserInfo }>();
        if (res.code === 200 && res.data) {
          setUserInfo(res.data);
        } else {
          setUserInfo(EMPTY_USER);
        }
      } catch {
        setUserInfo(EMPTY_USER);
      }
    };

    fetchUser();
  }, []);

  return userInfo;
}
